export const URIHead = "https://api.miisel.com/api/v1/"

export const URL_INSTA  = "https://www.instagram.com/miisel_jp/"
export const URL_X      = "https://twitter.com/miisel_jp"
